const bazarSl = {
	common: {
		brandLabel: 'වෙළඳ නාමය',
		storeLabel: 'සාප්පු',
		unitCount: '',
	},
	search: {
		placeholders: [
			'නිෂ්පාදනයක් සෙවෙන්න...',
			'වෙළඳ නාමයක් සෙවෙන්න...',
			'සාප්පු නාමයක් සෙවෙන්න...',
			'ප්‍රවර්ගයක් සෙවෙන්න...'
		]
	},
	sidebar: {
		categoriesTitle: 'ප්‍රවර්ග',
		storesTitle: 'සාප්පු',
	},
	store: {
		serviceAreaLabel: 'සේවා ප්‍රදේශය',
		nationwide: 'රට පුරා',
		productCount: 'නිෂ්පාදන',
		productsOfSuffix: 'නිෂ්පාදන',
		description: 'මෙම සාප්පුවෙන් ලබාගත හැකි සියලු නිෂ්පාදන පහතින් ඇත. ඔබට ප්‍රවර්ග අනුව පෙරහන් කළ හැක.'
	},
	buttons: {
		details: 'විස්තර',
		addToCart: 'කර්ට් එකට',
		clearFilters: 'පෙරහන් මකාදමන්න',
		close: 'වසන්න',
	},
	empty: {
		title: 'නිෂ්පාදන හමු නොවිනි',
		subtitle: 'කරුණාකර ඔබේ පෙරහන් හෝ සෙවුම් වෙනස් කරන්න',
	},
};

export default bazarSl;


